import { Environment } from '@40seas/entities/common';
import { ModalContextType } from '@40seas/frontend/libs/contexts';
import { useSetupData } from '@40seas/frontend/libs/hooks';
import { IntentsDataProvider } from '@40seas/payments-shared';
import { IntentData } from '../types';
import { useDashboardIntentsAuthProvider } from './useDashboardIntentsAuthProvider';

export const useModalContext = (environment: Environment, data?: IntentData): ModalContextType | undefined => {
    const { urls } = useSetupData();

    const authProvider = useDashboardIntentsAuthProvider(data);

    if (!data) return undefined;

    const intentType = data.intent.intentType;
    const dataProvider = new IntentsDataProvider(intentType, urls.API_URL, authProvider);

    return {
        intentType,
        urls,
        environment,
        dataProvider,
        isMobile: window.innerWidth <= 1000,
    };
};
